import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phonemask',
  standalone: false,
})
export class PhoneMaskPipe implements PipeTransform {
  transform(number: string): string {
    if (!number) return '';
    const trimNumberRemoveDashes = /[- )(]/g; // Removes dash char & trims string
    const regexNumber = number.replace(trimNumberRemoveDashes, '');
    const firstNum = regexNumber.slice(0, -7);
    const secondNum = regexNumber.slice(3, -4);
    const thirdNum = regexNumber.slice(6);
    return firstNum + '-' + secondNum + '-' + thirdNum;
  }
}
